import _ from "lodash";
import { CategoryTheme } from "../Components/misc";
import styles from "./theme.module.scss";

export const defaultColor = styles.defaultColor;

export const palettes: Record<CategoryTheme, string[]> = {
    billing: styles.billing.split(",").filter(d => d != null && d.toString().trim() !== ""),
    general: styles.general.split(",").filter(d => d != null && d.toString().trim() !== ""),
    "inputs-and-outputs": styles.inputsAndOutputs.split(",").filter(d => d != null && d.toString().trim() !== ""),
    "water-security": styles.waterSecurity.split(",").filter(d => d != null && d.toString().trim() !== ""),
    financials: styles.financials.split(",").filter(d => d != null && d.toString().trim() !== ""),
    "asset-condition": styles.assetCondition.split(",").filter(d => d != null && d.toString().trim() !== ""),
    "statewide-snapshot": styles.statewideSnapshot.split(",").filter(d => d != null && d.toString().trim() !== "")
};

export const main: Record<CategoryTheme, string> = {
    billing: styles.billingMain,
    general: styles.generalMain,
    "inputs-and-outputs": styles.inputsAndOutputsMain,
    "water-security": styles.waterSecurityMain,
    financials: styles.financialsMain,
    "asset-condition": styles.assetConditionMain,
    "statewide-snapshot": styles.statewideSnapshotMain
};

export const secondary: Record<CategoryTheme, string> = {
    billing: styles.billingSecondary,
    general: styles.generalSecondary,
    "inputs-and-outputs": styles.inputsAndOutputsSecondary,
    "water-security": styles.waterSecuritySecondary,
    financials: styles.financialsSecondary,
    "asset-condition": styles.assetConditionSecondary,
    "statewide-snapshot": styles.statewideSnapshotSecondary
};

export const getColor = (name: string) => {
    return main?.[name] ?? defaultColor;
};

export const getSecondaryColor = (name: string) => {
    return secondary?.[name] ?? defaultColor;
};

export const getTraceColors = (name: string, length: number, labels?: string[]): string[] => {
    if (labels?.length > 0) {
        const colors = getTraceColors(name, labels?.length);
        return labels.map((label, index) => {
            const camelLabel = _.camelCase(`${name}-${label}` ?? "");
            // console.log(camelLabel);
            return styles[camelLabel] ?? colors[index];
        });
    }

    const colors = getPalette(name) as string[];
    return Array(length)
        .fill(0)
        .map((___, index) => {
            return colors[index % length];
        });
};

export const getHighlightColors = (name: string, length: number) => {
    if (length == null || length < 1) return [];

    if (length === 1) return [getColor(name)];

    if (length === 2) return [getColor(name), getSecondaryColor(name)];

    return getTraceColors(name, length);
};

export const getPalette = (name: string) => {
    return palettes?.[name] ?? [defaultColor];
};
